// Uploaded card artwork URLs
export const BRAND_LOGO = "https://customer-assets-rejwkqb3.emergentagent.net/job_people-card-game/artifacts/w2xz7ujl_A1D853F5-5A78-4FD8-9764-0B88956CEFCB.png";

// Real production Trophy card artwork
export const TROPHY_CARD_ART = "https://customer-assets-rejwkqb3.emergentagent.net/job_people-card-game/artifacts/v1cfei8p_IMG_0473.webp";

// Real production Legendary card artwork — the rarest card in the deck
export const LEGENDARY_CARD_ART = "https://customer-assets-rejwkqb3.emergentagent.net/job_people-card-game/artifacts/hmyx4znt_IMG_0496.jpeg";

// Real production Chaos card artwork
export const CHAOS_ART = {
  swapHands:     "https://customer-assets-rejwkqb3.emergentagent.net/job_people-card-game/artifacts/9bl4819g_IMG_0493.webp",
  doubleTrouble: "https://customer-assets-rejwkqb3.emergentagent.net/job_people-card-game/artifacts/svcuyvhi_IMG_0494.webp",
  binIt:         "https://customer-assets-rejwkqb3.emergentagent.net/job_people-card-game/artifacts/llisrmen_IMG_0495.webp",
};

export const CARD_ASSETS = {
  quickMode: "https://customer-assets.emergentagent.com/job_949f3ba2-0378-4092-9909-f22525782706/artifacts/s34imtd6_IMG_8387.jpg",
  chaosMode: "https://customer-assets.emergentagent.com/job_949f3ba2-0378-4092-9909-f22525782706/artifacts/t4npc6rs_IMG_8401.webp",
  trophy:    TROPHY_CARD_ART,        // real Trophy card artwork
  swapHands: CHAOS_ART.swapHands,    // real Swap Hands chaos card
};

// Observation cards (the cards players spot in the real world)
export const SPOT_CARDS = [
  {
    key: "carryingFlowers",
    src: "https://customer-assets.emergentagent.com/job_people-card-game/artifacts/jnl45l69_IMG_8376.jpg",
    label: "Carrying Flowers",
    prompt: "Spot a person carrying flowers.",
    rarity: "RARE",
    points: 3,
  },
  {
    key: "streetPerformer",
    src: "https://customer-assets.emergentagent.com/job_people-card-game/artifacts/beld8im2_IMG_8377.jpg",
    label: "Street Performer",
    prompt: "Spot a person performing in the street.",
    rarity: "RARE",
    points: 3,
  },
  {
    key: "rollerSkates",
    src: "https://customer-assets.emergentagent.com/job_people-card-game/artifacts/v9itookp_IMG_8378.jpg",
    label: "Roller Skates",
    prompt: "Spot a person wearing roller skates.",
    rarity: "RARE",
    points: 3,
  },
  {
    key: "coupleKiss",
    src: "https://customer-assets.emergentagent.com/job_people-card-game/artifacts/utnhwqi7_IMG_8380.jpg",
    label: "Couple Kiss",
    prompt: "Spot a couple kissing.",
    rarity: "UNCOMMON",
    points: 2,
  },
];

// A single representative Chaos card and Trophy card for the categorised showcase.
export const CHAOS_CARDS = [
  {
    key: "swapHands",
    src: CHAOS_ART.swapHands,
    label: "Swap Hands",
    prompt: "Swap your entire hand with another player.",
  },
  {
    key: "doubleTrouble",
    src: CHAOS_ART.doubleTrouble,
    label: "Double Trouble",
    prompt: "Immediately pass two cards instead of one.",
  },
  {
    key: "binIt",
    src: CHAOS_ART.binIt,
    label: "Bin It",
    prompt: "Choose any active card and remove it from the game.",
  },
];

export const TROPHY_CARD = {
  key: "trophy",
  src: CARD_ASSETS.trophy,
  label: "The Trophy",
  prompt: "Spot something genuinely unusual, bizarre or extraordinary.",
};

export const LEGENDARY_CARD = {
  key: "fancyDress",
  src: LEGENDARY_CARD_ART,
  label: "Fancy Dress",
  prompt: "Spot a person wearing fancy dress.",
};

// Locations (in priority order, per launch brief)
export const WHERE_TO_PLAY = [
  { location: "Airports",       url: "https://images.unsplash.com/photo-1653795163859-9ee39ecc6d62?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwxfHxhaXJwb3J0JTIwdGVybWluYWwlMjBwZW9wbGUlMjB3YWl0aW5nfGVufDB8fHx8MTc4MzY3ODcwMHww&ixlib=rb-4.1.0&q=85" },
  { location: "Pubs",           url: "https://images.unsplash.com/photo-1766050163085-6e0a473b8b41?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwxfHxjcm93ZGVkJTIwQnJpdGlzaCUyMHB1YiUyMHBlb3BsZSUyMGRyaW5raW5nfGVufDB8fHx8MTc4MzY3ODcwMHww&ixlib=rb-4.1.0&q=85" },
  { location: "Cafés",          url: "https://images.unsplash.com/photo-1508766917616-d22f3f1eea14?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHxidXN5JTIwY296eSUyMGNvZmZlZSUyMHNob3AlMjBwZW9wbGV8ZW58MHx8fHwxNzgzNjc4NzAwfDA&ixlib=rb-4.1.0&q=85" },
  { location: "Holidays",       url: "https://images.unsplash.com/photo-1562866470-3774249bef10?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwxfHxob2xpZGF5JTIwcmVzb3J0JTIwcG9vbCUyMHBlb3BsZXxlbnwwfHx8fDE3ODM2Nzg3MDB8MA&ixlib=rb-4.1.0&q=85" },
  { location: "Festivals",      url: "https://images.unsplash.com/photo-1684348406379-950ef79e81c9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwxfHxtdXNpYyUyMGZlc3RpdmFsJTIwY3Jvd2QlMjBzdW5zZXR8ZW58MHx8fHwxNzgzNjc4NzAwfDA&ixlib=rb-4.1.0&q=85" },
  { location: "Train Journeys", url: "https://images.unsplash.com/photo-1688248018567-a9a857387e86?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHx0cmFpbiUyMGpvdXJuZXklMjBsb29raW5nJTIwb3V0JTIwd2luZG93fGVufDB8fHx8MTc4MzY3ODcwMHww&ixlib=rb-4.1.0&q=85" },
  { location: "Cruises",        url: "https://images.unsplash.com/photo-1617170708937-fbde03176e14?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwxfHxjcnVpc2UlMjBzaGlwJTIwZGVjayUyMHBlb3BsZSUyMHJlbGF4aW5nfGVufDB8fHx8MTc4MzY3ODcwMHww&ixlib=rb-4.1.0&q=85" },
  { location: "Campsites",      url: "https://images.unsplash.com/photo-1475483768296-6163e08872a1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwxfHxmcmllbmRzJTIwYXQlMjBjYW1wc2l0ZSUyMGZpcmV8ZW58MHx8fHwxNzgzNjc4NzAwfDA&ixlib=rb-4.1.0&q=85" },
];
